const OFFSET = 8;
const getPosition = (triggerRectParam, tooltipRectParam, position)=>{
    const triggerRect = {
        bottom: Number(triggerRectParam.bottom),
        height: Number(triggerRectParam.height),
        left: Number(triggerRectParam.left),
        right: Number(triggerRectParam.right),
        top: Number(triggerRectParam.top),
        width: Number(triggerRectParam.width)
    };
    const tooltipRect = {
        bottom: Number(tooltipRectParam.bottom),
        height: Number(tooltipRectParam.height),
        left: Number(tooltipRectParam.left),
        right: Number(tooltipRectParam.right),
        top: Number(tooltipRectParam.top),
        width: Number(tooltipRectParam.width)
    };
    const collisions = {
        top: triggerRect.top - tooltipRect.height < 0,
        right: window.innerWidth < triggerRect.left + tooltipRect.width,
        bottom: window.innerHeight < triggerRect.bottom + tooltipRect.height + OFFSET,
        left: triggerRect.left - tooltipRect.width < 0
    };
    const directionRight = collisions.right && !collisions.left;
    const directionUp = collisions.bottom && !collisions.top;
    if ('right' === position) return [
        {
            left: collisions.right ? triggerRect.right - triggerRect.width - tooltipRect.width - OFFSET + window.pageXOffset : triggerRect.left + triggerRect.width + OFFSET + window.pageXOffset,
            top: directionUp ? triggerRect.top - OFFSET - tooltipRect.height + window.pageYOffset : triggerRect.top + window.pageYOffset
        },
        collisions
    ];
    if ('left' === position) return [
        {
            left: collisions.left ? triggerRect.left + triggerRect.width + OFFSET + window.pageXOffset : triggerRect.right - triggerRect.width - tooltipRect.width - OFFSET + window.pageXOffset - 4,
            top: directionUp ? triggerRect.top - OFFSET - tooltipRect.height + window.pageYOffset : triggerRect.top + window.pageYOffset
        },
        collisions
    ];
    if ('top' === position) return [
        {
            left: directionRight ? triggerRect.right - tooltipRect.width + window.pageXOffset : triggerRect.left + window.pageXOffset,
            top: collisions.top ? triggerRect.top + OFFSET + triggerRect.height + window.pageYOffset + 8 : triggerRect.top - OFFSET - tooltipRect.height + window.pageYOffset
        },
        collisions
    ];
    return [
        {
            left: directionRight ? triggerRect.right - tooltipRect.width + window.pageXOffset : triggerRect.left + window.pageXOffset,
            top: directionUp ? triggerRect.top - OFFSET - tooltipRect.height + window.pageYOffset : triggerRect.top + OFFSET + triggerRect.height + window.pageYOffset + 8
        },
        collisions
    ];
};
const helpers_getPosition = getPosition;
export default helpers_getPosition;
